import { TrayArrowDownIcon } from './TrayArrowDownIcon';

/**
 * author: arnoldlepineux
 * id 8B1B6ED1-8AA5-4888-8477-B122FB236E1D
 * name tray-arrow-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-arrow-down.svg
 * tags
 * - Arrow 
 */
export const TrayDownloadIcon = TrayArrowDownIcon;
export default TrayDownloadIcon